<template>
  <div class="ui-content">
    <div class="ui-box">
      <el-form ref="form" class="ui-box-from-prenatalDetail" label-position="right" :model="form" label-width="150px">
        <div class="ui-box-item">
          <titleComponents :show.sync="show" name="问医信息"></titleComponents>
          <div class="itemInfo-detail" v-show="show">
            <div class="baseInfo-content mb10">
              <div class="text">昵称：{{form.userName||''}}</div>
              <div class="text">手机号：{{form.phone||''}}</div>
              <div class="text">预产期：{{new Date(form.prepareProduction).format('yyyy-MM-dd')}}</div>
            </div>
            <div class="baseInfo-content">
              <div class="text">所在医院：{{form.tbHospitalName||''}}</div>
            </div>
            <div class="baseInfo-content">
              <div class="text">医生姓名：{{form.tbDoctorName||''}}</div>
            </div>
            <div class="baseInfo-content  mb10">
              <div class="text bold">本次问医内容</div>
            </div>
            <div class="baseInfo-content mb10">
              <div class="text">提问时间：{{form.createTime||''}}</div>
            </div>
            <div class="baseInfo-content mb10">
              <div class="text blue">监护目的：{{form.tbPurpose||''}} - {{form.tbStatus||''}}</div>
            </div>
            <div class="baseInfo-content mb10" v-if="form.tbMomReason">
              <div class="text blue">母胎因素：{{form.tbMomReason||''}}</div>
            </div>
            <div class="baseInfo-content mb10" v-if="form.tbBabyReason">
              <div class="text blue">胎儿因素：{{form.tbBabyReason||''}}</div>
            </div>
            <div class="baseInfo-content mb10" v-if="form.tbRemarks">
              <div class="text blue">症状描述：{{form.tbRemarks||''}}</div>
            </div>
            <template v-if="form.tbReplyTime">
              <div class="baseInfo-content  mb10">
                <div class="text bold">本次回复内容</div>
              </div>
              <div class="baseInfo-content mb10">
                <div class="text">回复时间：{{form.tbReplyTime||''}}</div>
              </div>
              <div class="baseInfo-content mb10">
                <div class="text">{{form.tbReply||''}}</div>
              </div>
            </template>
            <template v-if="form.tbSecondAskTime">
              <div class="baseInfo-content  mb10">
                <div class="text bold">第二次提问</div>
              </div>
              <div class="baseInfo-content mb10">
                <div class="text">提问时间：{{form.tbSecondAskTime||''}}</div>
              </div>
              <div class="baseInfo-content mb10">
                <div class="text">提问内容：{{form.tbSecondAsk||''}}</div>
              </div>
            </template>
            <template v-if="form.tbSecondReplyTime">
              <div class="baseInfo-content  mb10">
                <div class="text bold">第二次回复</div>
              </div>
              <div class="baseInfo-content mb10">
                <div class="text">回复时间：{{form.tbSecondReplyTime||''}}</div>
              </div>
              <div class="baseInfo-content mb10">
                <div class="text">回复内容：{{form.tbSecondReply||''}}</div>
              </div>
            </template>
            <template v-if="form.tbThirdAskTime">
              <div class="baseInfo-content  mb10">
                <div class="text bold">第三次提问</div>
              </div>
              <div class="baseInfo-content mb10">
                <div class="text">提问时间：{{form.tbThirdAskTime||''}}</div>
              </div>
              <div class="baseInfo-content mb10">
                <div class="text">提问内容：{{form.tbThirdAsk||''}}</div>
              </div>
            </template>
            <template v-if="form.tbThirdReplyTime">
              <div class="baseInfo-content  mb10">
                <div class="text bold">第三次回复</div>
              </div>
              <div class="baseInfo-content mb10">
                <div class="text">回复时间：{{form.tbThirdReplyTime||''}}</div>
              </div>
              <div class="baseInfo-content mb10">
                <div class="text">回复内容：{{form.tbThirdReply||''}}</div>
              </div>
            </template>
          </div>
        </div>
        <heartInfo :data.sync="form.tbCardiacDevice" :type='1'></heartInfo>
        <heartInfo v-if="form.tbCardiacDevice.tbIsHasFhr2" :data.sync="form.tbCardiacDevice" :type='2'></heartInfo>
        <div class="ui-box-item" v-if="isUnreply">
          <titleComponents :show.sync="replyShow" name="回复判断结果"></titleComponents>
          <div class="itemInfo-detail flex" v-show="replyShow">
            <div class="text" style="width:70px">文字内容</div>
            <el-input class="width439" type="textarea" :rows="4" v-model="tbReply">
            </el-input>
          </div>
          <el-button type="primary" style="margin:0 24px 24px" @click="replyAskOrder">确认</el-button>
        </div>
      </el-form>
      <div class="ui-box-prenatalDetail-button">
        <el-button class="return" @click="returnList">返回列表</el-button>
      </div>
    </div>
  </div>
</template>

<script>
const files = require.context('/', false, /\.vue$/);
const suffixList = files.id
  .split(' ')[0]
  .split('/')
  .filter((a, b) => b > 2);
const fileName = 'unreplyDetail';
const controller = 'user';
const parentName = '待回复';
import titleComponents from '@/components/mother/title'
import baseInfo from '@/components/heartDetail/baseInfo'
import heartInfo from '@/components/heartDetail/heartInfo'
import { mapGetters } from 'vuex';
export default {
  name: `${suffixList.join('')}${fileName}`,
  data () {
    const _this = this;
    return {
      tbReply: '',
      replyShow: true,
      form: {
        tbCardiacDevice: {}
      },
      show: true,
      pathCode: `${suffixList.join('')}${fileName}`,
      loading: false,
      filePath: ['', ...suffixList, fileName].join('/'),
      fileName: fileName,
      form: {
      },
    };
  },
  computed: {
    isUnreply () {
      if (!this.form.tbReplyTime || (this.form.tbSecondAskTime && !this.form.tbSecondReplyTime) || (this.form.tbThirdAskTime && !this.form.tbThirdReplyTime)) {
        return 1
      } else {
        return 0
      }
    },
    isSee () {
      return false;
    },
    pageType () {
      return 'edit';
    },
    ...mapGetters(['lastBreadCrumb', 'refreshPage'])
  },
  watch: {
    $route (to, from) {
      if (to.path === this.filePath && this.refreshPage) {
        this.init();
        this.$store.dispatch('setRefreshPage', false);
      }
    }
  },
  methods: {
    clear () {
      this.form = {
        tbCardiacDevice: {}
      }
    },
    init () {
      this.clear();
      this.getById(this.$route.query.tbId);
    },
    sendAskOrderMessage () {
      let option = {
        type: "cmd",
        chatType: "singleChat",
        to: this.form.userUuid,
        action: "action",
        ext: { MessageType: "askOrder" },
      };
      let msg = WebIM.message.create(option);
      WebIM.conn.send(msg)
    },
    initForm (form) {
      form.tbCardiacDevice.username = form.userName
      form.tbCardiacDevice.phone = form.phone
      form.tbCardiacDevice.currentGeneration = form.currentGeneration
      form.tbCardiacDevice.prepareProduction = form.prepareProduction
      form.tbCardiacDevice.week = form.tbCardiacDevice.tbWeek || form.week
      form.tbCardiacDevice.birthday = form.tbBirthday
      form.tbCardiacDevice.tbHospitalName = form.tbHospitalName
      form.tbCardiacDevice.age = form.age = this.calculateAge(form.tbBirthday)
      return form;
    },
    calculateAge (birthDate) {
      if (!birthDate) {
        return ''
      }
      birthDate = new Date(birthDate)
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      // 如果当前月份小于出生月份，或者月份相同但日期小于出生日期，则年龄减1
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    replyAskOrder () {
      if (!this.tbReply) {
        this.$message.error('请输入回复内容');
        return;
      }
      this.$http.post(`/order/replyAskOrder`, { tbReply: this.tbReply, tbId: this.form.tbId }).then((res) => {
        if (res.code === 1000) {
          this.$message.success('回复成功')
          this.getById(this.form.tbId)
          this.sendAskOrderMessage()
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getById (id) {
      this.$http.get(`/${controller}/findAskOrderDetail`, { tbId: id }).then((res) => {
        if (res.code === 1000) {
          this.form = this.initForm(res.data);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    returnList () {
      this.closeTab(
        this.filePath,
        parentName,
        this.fileName,
        ['', ...suffixList].join('/'),
        true
      );
    }
  },
  created () {
    this.init();

  },
  mounted () { },
  destroyed () { },
  components: {
    titleComponents,
    baseInfo,
    heartInfo
  }
};
</script>

<style lang="scss" scoped>
.ui-content {
  width: 100%;
  height: 100%;
  .ui-box {
    overflow-x: auto;
    margin: 0 24px;
    padding-bottom: 24px;
    width: calc(100% - 48px);
    min-height: calc(100% - 24px);
    height: auto;
    background: #ffffff;
    border-radius: 2px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    .ui-box-from-prenatalDetail {
      padding-top: 4px;
      .ui-box-item {
        margin: 20px 24px 0;
        background: rgba(0, 0, 0, 0.02);
        box-sizing: border-box;
        width: calc(100% - 48px);
        .itemInfo-detail {
          border-top: 1px solid #e5e5e5;
          width: 100%;
          padding: 20px;
          box-sizing: border-box;
          &.flex {
            display: flex;
          }
          .baseInfo-content {
            display: flex;
            align-content: center;
            margin-bottom: 25px;
            &.mb10 {
              margin-bottom: 10px;
            }
            .text {
              font-weight: 400;
              font-size: 14px;
              color: #000000;
              line-height: 22px;
              margin-right: 60px;
              &.bold {
                font-weight: bold;
              }
              &.blue {
                color: #69c2ff;
              }
            }
          }
          .ui-box-table {
            table-layout: fixed;
            text-align: center;
            width: 100%;
            border: 1px solid #d8d8d8;
            border-radius: 6px;
            border-collapse: collapse;
            border-style: hidden;
            box-shadow: 0 0 0 1px #e0e0e0;
            overflow: hidden;
            tr {
              border: 1px solid #e0e0e0;
              height: 54px;
              line-height: 54px;
              th {
                background: #ffffff;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 700;
                color: #000000;
                text-align: center;
                border: 1px solid #e0e0e0;
              }
              td {
                background: #ffffff;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #000000;
                border: 1px solid #e0e0e0;
              }
            }
          }
        }
      }
      .ui-box-prenatalDetail-button {
        margin-left: 217px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #555555;
        .return {
          margin-top: 20px;
          padding: 6px 25px;
          margin-right: 40px;
          border-radius: 3px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          line-height: 22px;
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
}
.ui-content {
  width: 100%;
  height: 100%;
  .ui-box {
    margin: 0 24px;
    padding-bottom: 24px;
    width: calc(100% - 48px);
    min-height: calc(100% - 24px);
    height: auto;
    background: #ffffff;
    border-radius: 2px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    .ui-box-from-prenatalDetail {
      padding-top: 4px;
      .ui-box-item {
        margin: 20px 24px 0;
        background: rgba(0, 0, 0, 0.02);
        box-sizing: border-box;
        width: calc(100% - 48px);
        .itemInfo-detail {
          border-top: 1px solid #e5e5e5;
          width: 100%;
          padding: 20px;
          box-sizing: border-box;
          &.flex {
            display: flex;
          }
          .baseInfo-content {
            display: flex;
            align-content: center;
            margin-bottom: 25px;
            &.mb10 {
              margin-bottom: 10px;
            }
            .text {
              font-weight: 400;
              font-size: 14px;
              color: #000000;
              line-height: 22px;
              margin-right: 60px;
              &.blue {
                color: #69c2ff;
              }
            }
          }
          .ui-box-table {
            table-layout: fixed;
            text-align: center;
            width: 100%;
            border: 1px solid #d8d8d8;
            border-radius: 6px;
            border-collapse: collapse;
            border-style: hidden;
            box-shadow: 0 0 0 1px #e0e0e0;
            overflow: hidden;
            tr {
              border: 1px solid #e0e0e0;
              height: 54px;
              line-height: 54px;
              th {
                background: #ffffff;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 700;
                color: #000000;
                text-align: center;
                border: 1px solid #e0e0e0;
              }
              td {
                background: #ffffff;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #000000;
                border: 1px solid #e0e0e0;
              }
            }
          }
        }
      }
    }
    .ui-box-prenatalDetail-button {
      margin-left: 217px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #555555;
      .return {
        margin-top: 20px;
        padding: 6px 25px;
        margin-right: 40px;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        line-height: 22px;
        &:focus {
          outline: none;
        }
      }
    }
  }
}
</style>